import VerifyOtp from "../../../../component/verify_otp";
import EnterEmailMobile from "../../../../component/enter_email_mobile";

import { useEffect, useState } from "react";
import {
  actionLogin,
  actionLoginSendOtp,
  actionLoginVerifyOtp,
  resetLoginOtpResponse,
  resetVerifyLoginOtpResponse,
  actionRegistrationForm,
  resetRegistrationFormResponse,
  actionVerifyRegOtp,
  resetVerifyRegOtpResponse,
} from "../store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Registration from "../../../../component/registration_form";
import VerifyRegOtp from "../../../../component/verify_reg_otp";
import LandingSection from "../landing_section";
import { SUB_DIRECTORY } from "../../../../common/constant";
import { jwtDecode } from "jwt-decode";
import { getNextScreen } from "../../../../utils";
const RegistrationPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // OTP- response
  const { getLoginOtp } = useSelector((state) => ({
    ...state.publicStore,
  }));

  // Login VerifyLoginOTP
  const { getVerifyLoginOtp } = useSelector((state) => ({
    ...state.publicStore,
  }));

  // Registration Form
  const { registrationForm, getVerifyRegOtp } = useSelector((state) => ({
    ...state.publicStore,
  }));

  const [screenMode, setscreenMode] = useState("sendotp");
  const [loginData, setLoginData] = useState({ code: "axis" });
  const [getRegistration, setRegistration] = useState(false);
  const [regData, setRegData] = useState();
  const [regUser, setRegUser] = useState(false);

  const [verifiedUser, setVerifiedUser] = useState(false);
  const bannerHeading = {
    // backgroundColor: "rgba(237,17,100,0.2)",

    fontSize: "34px",
    fontWeight: "900",
    lineHeight: "38.43px",
    // letterSpacing: "-0.01em",
  };
  const copyrightText = {
    // backgroundColor: "rgba(237,17,100,0.2)",
    fontSize: "14px",
    fontWeight: "bold",
  }

  // api call on update ---- > when response is true
  // setGetOTP(true)

  useEffect(() => {
    if (getLoginOtp !== null) {
      dispatch(resetLoginOtpResponse());
      if (getLoginOtp?.status === true) {
        setscreenMode("verifyotp");
      } else {
        toast.error(getLoginOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      }
    }
  }, [getLoginOtp]);

  useEffect(() => {
    if (getVerifyLoginOtp !== null) {
      dispatch(resetVerifyLoginOtpResponse());
      if (getVerifyLoginOtp?.status) {
        localStorage.setItem(
          "userData",
          JSON.stringify(getVerifyLoginOtp.data.userData)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(getVerifyLoginOtp.data.token)
        );
        const decoded = jwtDecode(getVerifyLoginOtp?.data?.token);
        getNextScreen(decoded?.role)
        // window.location.replace("/corporate/dashboard");
        // window.location.reload();

        navigate("/policies");
      } else {

        toast.error(getLoginOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [getVerifyLoginOtp]);

  useEffect(() => {
    if (registrationForm !== null) {
      dispatch(resetRegistrationFormResponse());
      if (registrationForm?.status === true) {
        setRegUser(true);
      } else {
        toast.error(registrationForm?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  });

  useEffect(() => {
    if (getVerifyRegOtp !== null) {
      dispatch(resetVerifyRegOtpResponse());
      // if (getVerifyRegOtp?.status && getVerifyRegOtp?.data?.is_verified) {
      if (getVerifyRegOtp?.status) {
        // localStorage.setItem(
        //   "userData",
        //   JSON.stringify(getVerifyRegOtp.data.userData)
        // );
        // localStorage.setItem(
        //   "token",
        //   JSON.stringify(getVerifyRegOtp.data.token)
        // );
        // localStorage.setItem("next", getVerifyRegOtp?.data?.next);
        // // alert(getVerifyRegOtp?.data?.next)
        // // window.location.replace("/corporate/dashboard");
        // navigate("/policies");

        // window.location.reload();
        toast.success(getVerifyRegOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
        navigate("/login")

      } else {
        toast.error(getVerifyRegOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [getVerifyRegOtp]);

  return (
    <div className="">
      <section>
        <div className="full-banner pt-5">
          <div className="container-xxl container-fluid">
            <div className="row justify-content-end">
              <div className="col-12 col-md-10 pt-5 pb-3 text-center">
                <span style={bannerHeading}>Experience an enhanced motor fleet policy <br />for your peace of mind</span>
              </div>
            </div>
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-12 col-md-4 my-auto order-md-2 h-100">
                <div className="px-3 card">
                  <div className="card-body py-4">
                    {!regUser && (
                      <Registration
                        handleReg={(data) => {
                          setRegData(data);
                          dispatch(actionRegistrationForm(data));
                        }}
                      />
                    )}

                    {regUser && (
                      <VerifyRegOtp
                        handleRegOtp={(data) => {
                          dispatch(actionVerifyRegOtp({ ...data, ...regData }));
                        }}
                      />
                    )}
                  </div>

                </div>
                <div className="text-center mt-3">
                  Already have an account? <a href="/login" className="text-primary text-decoration-underline" >
                    Login
                  </a>
                </div>
              </div>

              <div class="col-md-6 my-auto order-md-1 d-none d-md-inline text-end">
                <LandingSection />
              </div>
            </div>

            <div className="row justify-content-end">
              <div className="col-12 col-md-10 pt-4 text-center" >
                <span style={copyrightText}>
                  © All Rights Reserved. Copyright {new Date().getFullYear()} Pioneer Insurance & Reinsurance Broker Pvt. Ltd.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegistrationPage;
